import react, {useEffect, useRef} from 'react';

interface useThrottleProps {
    condition?: boolean
    timeout: number
    action: (...args) => any
    trigger: any,
}

const useThrottle = ({condition = true, timeout, action, trigger}: useThrottleProps) => {
    const lastExecuted = useRef<number>();
    
    useEffect(() => {
        if (condition) {
            if (Date.now() >= lastExecuted.current + timeout) {
                lastExecuted.current = Date.now();
                action();
    
            }else {
                const throttleTimer = setTimeout(() => {
                  lastExecuted.current = Date.now()
                  action();
            }, timeout)
          
            return () => clearTimeout(throttleTimer)
            }
        }
    },[trigger]) 
}

export default useThrottle;